import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[(!_vm.is_tv)?_c('main-dash'):_vm._e(),(_vm.is_tv)?_c('main-dash-tv'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }